/**
 * @return: return an empty function
 */
export default function () {
  let noop = function () {}
  return noop
}
